import React from "react"
import SinglePreviewCard from "./SinglePreviewCard"
import { DETAIL_PAGE_GENERAL_INFO_ANCHOR_KEY } from "config/PageAnchorConfig/CampaignAnchorConfig";


const cardInfo = [
  {
    sectionTitle: "GENERAL",
    anchorKey: DETAIL_PAGE_GENERAL_INFO_ANCHOR_KEY.generalInfo.sectionKey,
    sectionContent: [
      {
        title: "Status",
        field: 'displayStatus',
        anchorKey: DETAIL_PAGE_GENERAL_INFO_ANCHOR_KEY.generalInfo.sectionContent.campaignStatus,
      },
      {
        title: "Creation time",
        field: 'displayCreationDate',
        anchorKey: DETAIL_PAGE_GENERAL_INFO_ANCHOR_KEY.generalInfo.sectionContent.creationTime,
      },
      {
        title: "Last modified time",
        field: 'displayLastModifiedDate',
        anchorKey: DETAIL_PAGE_GENERAL_INFO_ANCHOR_KEY.generalInfo.sectionContent.lastModifiedTime,
      },
      {
        title: "Last modified by",
        field: 'displayLastModifiedBy',
        anchorKey: DETAIL_PAGE_GENERAL_INFO_ANCHOR_KEY.generalInfo.sectionContent.lastModifiedBy,
      },
    ]
  },
];

const DetailGeneralInfoCard = ({
  campaignData,
  language,
}) => {
  return (
    <SinglePreviewCard
      language={language}
      data={campaignData}
      cardInfo={cardInfo}
      errors={[]}
      hideEditButton
    />
  )
}

export default DetailGeneralInfoCard;
